import ROUTES from '../routes';
import ChartsOfAccountsPage from "../hoc/charts";
import ColumnPrimaryAccounts from "../hoc/charts/primary-accounts";
import PrimaryAccountCreate from '../hoc/charts/primary-accounts/create';
import PrimaryAccountEdit from '../hoc/charts/primary-accounts/edit';
import ColumnCategories from "../hoc/charts/categories";
import CategoryCreate from '../hoc/charts/categories/create';
import CategoryEdit from '../hoc/charts/categories/edit';
import ColumnGroups from "../hoc/charts/groups";
import GroupCreate from '../hoc/charts/groups/create';
import GroupEdit from '../hoc/charts/groups/edit';

const ChartsRoutes = {
  path: ROUTES.CHARTS_OF_ACCOUNTS,
  element: <ChartsOfAccountsPage />,
  children: [
    {
      element: <ColumnCategories />,
      index: true,
    },
    {
      path: ROUTES.CATEGORIES,
      element: <ColumnCategories />,
      children: [
        {
          element: <ColumnGroups />,
          index: true,
        },
        {
          path: ROUTES.GROUPS,
          element: <ColumnGroups />,
          children: [
            {
              element: <ColumnPrimaryAccounts />,
              index: true,
            },
            {
              path: ROUTES.PRIMARY_ACCOUNTS,
              element: <ColumnPrimaryAccounts />,
              children: [
                {
                  path: ROUTES.CATEGORY_ADD,
                  element: <CategoryCreate />,
                },
                {
                  path: ROUTES.CATEGORY_EDIT,
                  element: <CategoryEdit />,
                },
                {
                  path: ROUTES.GROUP_ADD,
                  element: <GroupCreate />,
                },
                {
                  path: ROUTES.GROUP_EDIT,
                  element: <GroupEdit />,
                },
                {
                  path: ROUTES.PRIMARY_ACCOUNT_ADD,
                  element: <PrimaryAccountCreate />,
                },
                {
                  path: ROUTES.PRIMARY_ACCOUNT_EDIT,
                  element: <PrimaryAccountEdit />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default ChartsRoutes;
